module.exports = __webpack_public_path__ + "img/6082a91.png";